import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConcise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconConcise"><Path fillRule="evenodd" clipRule="evenodd" d="M9 2.68933L12 5.68933L15 2.68933L16.0607 3.74999L12 7.81065L7.93934 3.74999L9 2.68933ZM3 9.49999H21V11H3V9.49999ZM3 13H21V14.5H3V13ZM12 16.1893L16.0607 20.25L15 21.3106L12 18.3107L9 21.3106L7.93934 20.25L12 16.1893Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConcise;
